import React, { useState } from 'react';
import { AlertCircleIcon, BellIcon, CheckCircleIcon, XCircleIcon, ClockIcon, ServerIcon, ShieldIcon, FileTextIcon, SearchIcon, FilterIcon, SettingsIcon, TrashIcon, CheckIcon, DatabaseIcon, CalendarIcon, UserIcon, XIcon, WrenchIcon } from 'lucide-react';
export const Notifications: React.FC = () => {
  // State for notification filters
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [priorityFilter, setPriorityFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [showSettings, setShowSettings] = useState(false);
  // Sample notification data
  const notifications = [{
    id: 1,
    title: 'Server BINDA Sumbar Offline',
    description: 'Node srv-binda-sumbar-01 tidak merespon sejak 10:15 WIB. Tim teknis telah dikirim ke lokasi.',
    time: '2 jam yang lalu',
    category: 'infrastructure',
    priority: 'critical',
    icon: <ServerIcon size={20} className="text-white" data-id="element-2447" />,
    iconBg: 'bg-accent-red',
    read: false
  }, {
    id: 2,
    title: 'CPU Load Tinggi pada srv-binda-jatim-01',
    description: 'CPU load > 90% selama 15 menit terakhir. Monitoring berlanjut.',
    time: '3 jam yang lalu',
    category: 'infrastructure',
    priority: 'warning',
    icon: <ServerIcon size={20} className="text-white" data-id="element-2448" />,
    iconBg: 'bg-yellow-500',
    read: false
  }, {
    id: 3,
    title: 'Kontrak Lisensi Oracle BINDA Jatim',
    description: 'Kontrak akan berakhir dalam 45 hari. Mohon segera ajukan perpanjangan.',
    time: '5 jam yang lalu',
    category: 'contract',
    priority: 'info',
    icon: <FileTextIcon size={20} className="text-white" data-id="element-2449" />,
    iconBg: 'bg-accent-info',
    read: false
  }, {
    id: 4,
    title: 'Login Anomali Terdeteksi',
    description: 'User hwijaya login dari lokasi tidak biasa (Bandung). Verifikasi OTP telah dilakukan.',
    time: '6 jam yang lalu',
    category: 'security',
    priority: 'critical',
    icon: <ShieldIcon size={20} className="text-white" data-id="element-2450" />,
    iconBg: 'bg-accent-red',
    read: false
  }, {
    id: 5,
    title: 'Pemeliharaan Router Backbone STIN',
    description: 'Health score menurun menjadi 65%. Jadwalkan pemeliharaan segera.',
    time: '8 jam yang lalu',
    category: 'maintenance',
    priority: 'warning',
    icon: <WrenchIcon size={20} className="text-white" data-id="element-2451" />,
    iconBg: 'bg-yellow-500',
    read: false
  }, {
    id: 6,
    title: 'Pemeliharaan Server Database Utama Selesai',
    description: 'Pemeliharaan rutin telah selesai. Health score meningkat menjadi 85%.',
    time: '1 hari yang lalu',
    category: 'maintenance',
    priority: 'success',
    icon: <CheckCircleIcon size={20} className="text-white" data-id="element-2452" />,
    iconBg: 'bg-green-500',
    read: true
  }, {
    id: 7,
    title: 'Backup Database Gagal',
    description: 'Backup otomatis database pusat gagal pada pukul 02:00 WIB. Cek log untuk detail.',
    time: '1 hari yang lalu',
    category: 'infrastructure',
    priority: 'critical',
    icon: <DatabaseIcon size={20} className="text-white" data-id="element-2453" />,
    iconBg: 'bg-accent-red',
    read: true
  }, {
    id: 8,
    title: 'Update Sistem Berhasil',
    description: 'Update sistem keamanan v2.4.5 berhasil diterapkan pada seluruh node.',
    time: '2 hari yang lalu',
    category: 'security',
    priority: 'success',
    icon: <ShieldIcon size={20} className="text-white" data-id="element-2454" />,
    iconBg: 'bg-green-500',
    read: true
  }, {
    id: 9,
    title: 'Rapat Evaluasi Aset Q3',
    description: 'Reminder: Rapat evaluasi aset kuartal 3 akan dilaksanakan besok pukul 10:00 WIB.',
    time: '2 hari yang lalu',
    category: 'reminder',
    priority: 'info',
    icon: <CalendarIcon size={20} className="text-white" data-id="element-2455" />,
    iconBg: 'bg-accent-info',
    read: true
  }, {
    id: 10,
    title: 'Pengguna Baru Ditambahkan',
    description: 'Admin telah menambahkan pengguna baru: Budi Santoso (BINDA Jatim).',
    time: '3 hari yang lalu',
    category: 'user',
    priority: 'info',
    icon: <UserIcon size={20} className="text-white" data-id="element-2456" />,
    iconBg: 'bg-accent-info',
    read: true
  }];
  // Filter notifications based on category, priority and search
  const filteredNotifications = notifications.filter(notification => {
    const matchesCategory = categoryFilter === 'all' || notification.category === categoryFilter;
    const matchesPriority = priorityFilter === 'all' || notification.priority === priorityFilter;
    const matchesSearch = notification.title.toLowerCase().includes(searchTerm.toLowerCase()) || notification.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesPriority && matchesSearch;
  });
  // Count unread notifications
  const unreadCount = notifications.filter(n => !n.read).length;
  const criticalCount = notifications.filter(n => n.priority === 'critical' && !n.read).length;
  const warningCount = notifications.filter(n => n.priority === 'warning' && !n.read).length;
  // Mark all as read
  const handleMarkAllAsRead = () => {
    alert('Semua notifikasi telah ditandai sebagai terbaca');
  };
  // Mark single notification as read
  const handleMarkAsRead = (id: number) => {
    alert(`Notifikasi #${id} ditandai sebagai terbaca`);
  };
  // Toggle notification settings
  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };
  return <div className="space-y-4" data-id="element-2457">
      {/* Header - Full width */}
      <div className="flex items-center justify-between mb-4" data-id="element-2458">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-2459">
          <AlertCircleIcon size={24} className="mr-2" data-id="element-2460" />
          Notification & Incident Center
          {unreadCount > 0 && <span className="ml-3 bg-accent-red text-white text-xs px-2 py-1 rounded-full" data-id="element-2461">
              {unreadCount} baru
            </span>}
        </h1>
        <div className="flex space-x-2" data-id="element-2462">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" onClick={handleMarkAllAsRead} data-id="element-2463">
            Tandai Semua Terbaca
          </button>
          <button className={`bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium flex items-center`} onClick={toggleSettings} data-id="element-2464">
            <SettingsIcon size={18} className="mr-2" data-id="element-2465" />
            Pengaturan Notifikasi
          </button>
        </div>
      </div>
      {/* Filters and Search - Full width */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-4" data-id="element-2466">
        <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-2467">
          <div className="relative flex-grow max-w-md" data-id="element-2468">
            <input type="text" placeholder="Cari notifikasi..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-2469" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-2470" />
          </div>
          <div className="flex items-center gap-2" data-id="element-2471">
            <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-2472">
              <FilterIcon size={16} className="mr-1" data-id="element-2473" />
              Filter
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} data-id="element-2474">
              <option value="all" data-id="element-2475">Semua Kategori</option>
              <option value="infrastructure" data-id="element-2476">Infrastruktur</option>
              <option value="security" data-id="element-2477">Keamanan</option>
              <option value="maintenance" data-id="element-2478">Pemeliharaan</option>
              <option value="contract" data-id="element-2479">Kontrak & Lisensi</option>
              <option value="reminder" data-id="element-2480">Pengingat</option>
              <option value="user" data-id="element-2481">Pengguna</option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" value={priorityFilter} onChange={e => setPriorityFilter(e.target.value)} data-id="element-2482">
              <option value="all" data-id="element-2483">Semua Prioritas</option>
              <option value="critical" data-id="element-2484">Kritis</option>
              <option value="warning" data-id="element-2485">Peringatan</option>
              <option value="info" data-id="element-2486">Info</option>
              <option value="success" data-id="element-2487">Sukses</option>
            </select>
          </div>
        </div>
      </div>
      {/* Notifications List - Full width */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-4" data-id="element-2488">
        <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-2489">
          <h2 className="font-bold text-secondary flex items-center" data-id="element-2490">
            <BellIcon size={18} className="mr-2" data-id="element-2491" />
            Notifikasi Terbaru
          </h2>
          <div className="flex items-center space-x-2" data-id="element-2492">
            <span className="text-xs bg-accent-red text-white px-2 py-1 rounded-full" data-id="element-2493">
              {criticalCount} Kritis
            </span>
            <span className="text-xs bg-yellow-500 text-white px-2 py-1 rounded-full" data-id="element-2494">
              {warningCount} Warning
            </span>
          </div>
        </div>
        {filteredNotifications.length === 0 ? <div className="p-8 text-center" data-id="element-2495">
            <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-2496">
              <BellIcon size={32} className="text-gray-400" data-id="element-2497" />
            </div>
            <h3 className="text-lg font-medium text-secondary mb-1" data-id="element-2498">
              Tidak ada notifikasi
            </h3>
            <p className="text-gray-500" data-id="element-2499">
              Tidak ada notifikasi yang sesuai dengan filter yang dipilih
            </p>
          </div> : <div className="divide-y divide-gray-200 max-h-[600px] overflow-y-auto" data-id="element-2500">
            {filteredNotifications.map(notification => <div key={notification.id} className={`p-4 ${!notification.read ? notification.priority === 'critical' ? 'bg-red-50' : notification.priority === 'warning' ? 'bg-yellow-50' : 'bg-blue-50' : ''}`} data-id="element-2501">
                <div className="flex" data-id="element-2502">
                  <div className="flex-shrink-0 mr-3" data-id="element-2503">
                    <div className={`w-10 h-10 rounded-full ${notification.iconBg} flex items-center justify-center`} data-id="element-2504">
                      {notification.icon}
                    </div>
                  </div>
                  <div className="flex-grow" data-id="element-2505">
                    <div className="flex items-start justify-between" data-id="element-2506">
                      <div data-id="element-2507">
                        <h3 className="font-medium text-secondary" data-id="element-2508">
                          {notification.title}
                          {!notification.read && <span className="ml-2 w-2 h-2 inline-block bg-accent-red rounded-full" data-id="element-2509"></span>}
                        </h3>
                        <p className="text-sm text-gray-600 mt-1" data-id="element-2510">
                          {notification.description}
                        </p>
                      </div>
                      <span className="text-xs text-gray-500" data-id="element-2511">
                        {notification.time}
                      </span>
                    </div>
                    <div className="mt-2 flex justify-between items-center" data-id="element-2512">
                      <div className="flex items-center" data-id="element-2513">
                        <span className={`text-xs px-2 py-0.5 rounded-full mr-2 ${notification.priority === 'critical' ? 'bg-accent-red text-white' : notification.priority === 'warning' ? 'bg-yellow-500 text-white' : notification.priority === 'success' ? 'bg-green-500 text-white' : 'bg-accent-info text-white'}`} data-id="element-2514">
                          {notification.priority === 'critical' ? 'Kritis' : notification.priority === 'warning' ? 'Warning' : notification.priority === 'success' ? 'Sukses' : 'Info'}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-2515">
                          {notification.category === 'infrastructure' ? 'Infrastruktur' : notification.category === 'security' ? 'Keamanan' : notification.category === 'maintenance' ? 'Pemeliharaan' : notification.category === 'contract' ? 'Kontrak' : notification.category === 'reminder' ? 'Pengingat' : 'Pengguna'}
                        </span>
                      </div>
                      <div className="flex space-x-2" data-id="element-2516">
                        <button className="text-xs text-accent-info hover:underline" data-id="element-2517">
                          Lihat Detail
                        </button>
                        {!notification.read && <button className="text-xs text-gray-500 hover:underline" onClick={() => handleMarkAsRead(notification.id)} data-id="element-2518">
                            Tandai Terbaca
                          </button>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
      </div>
      {/* Three-column layout for status sections */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2519">
        {/* Active Incidents */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2520">
          <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2521">
            <h2 className="font-bold text-secondary" data-id="element-2522">Status Insiden Aktif</h2>
          </div>
          <div className="p-4" data-id="element-2523">
            <div className="space-y-4" data-id="element-2524">
              <div className="border-l-4 border-accent-red p-3 bg-red-50 rounded-r-lg" data-id="element-2525">
                <div className="flex justify-between items-start" data-id="element-2526">
                  <div data-id="element-2527">
                    <h3 className="font-medium text-secondary" data-id="element-2528">
                      Server BINDA Sumbar Offline
                    </h3>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-2529">
                      Started: 10:15 WIB (2 jam 45 menit)
                    </p>
                  </div>
                  <span className="text-xs bg-accent-red text-white px-2 py-0.5 rounded-full" data-id="element-2530">
                    Kritis
                  </span>
                </div>
                <div className="mt-2 space-y-2" data-id="element-2531">
                  <div className="flex items-center" data-id="element-2532">
                    <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center mr-2" data-id="element-2533">
                      <CheckCircleIcon size={12} className="text-white" data-id="element-2534" />
                    </div>
                    <span className="text-xs" data-id="element-2535">Insiden terdeteksi (10:15)</span>
                  </div>
                  <div className="flex items-center" data-id="element-2536">
                    <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center mr-2" data-id="element-2537">
                      <CheckCircleIcon size={12} className="text-white" data-id="element-2538" />
                    </div>
                    <span className="text-xs" data-id="element-2539">Tim teknis dikirim (10:45)</span>
                  </div>
                  <div className="flex items-center" data-id="element-2540">
                    <div className="w-5 h-5 rounded-full bg-yellow-500 flex items-center justify-center mr-2" data-id="element-2541">
                      <ClockIcon size={12} className="text-white" data-id="element-2542" />
                    </div>
                    <span className="text-xs" data-id="element-2543">
                      Diagnosis masalah (in progress)
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-2544">
                    <div className="w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-2545">
                      <XCircleIcon size={12} className="text-white" data-id="element-2546" />
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-2547">Perbaikan</span>
                  </div>
                  <div className="flex items-center" data-id="element-2548">
                    <div className="w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-2549">
                      <XCircleIcon size={12} className="text-white" data-id="element-2550" />
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-2551">Verifikasi</span>
                  </div>
                </div>
                <div className="mt-3 flex justify-end" data-id="element-2552">
                  <button className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-2553">
                    Lihat Detail
                  </button>
                </div>
              </div>
              <div className="border-l-4 border-yellow-500 p-3 bg-yellow-50 rounded-r-lg" data-id="element-2554">
                <div className="flex justify-between items-start" data-id="element-2555">
                  <div data-id="element-2556">
                    <h3 className="font-medium text-secondary" data-id="element-2557">
                      CPU Load Tinggi srv-binda-jatim-01
                    </h3>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-2558">
                      Started: 09:45 WIB (3 jam 15 menit)
                    </p>
                  </div>
                  <span className="text-xs bg-yellow-500 text-white px-2 py-0.5 rounded-full" data-id="element-2559">
                    Warning
                  </span>
                </div>
                <div className="mt-2 space-y-2" data-id="element-2560">
                  <div className="flex items-center" data-id="element-2561">
                    <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center mr-2" data-id="element-2562">
                      <CheckCircleIcon size={12} className="text-white" data-id="element-2563" />
                    </div>
                    <span className="text-xs" data-id="element-2564">Monitoring dimulai (09:45)</span>
                  </div>
                  <div className="flex items-center" data-id="element-2565">
                    <div className="w-5 h-5 rounded-full bg-yellow-500 flex items-center justify-center mr-2" data-id="element-2566">
                      <ClockIcon size={12} className="text-white" data-id="element-2567" />
                    </div>
                    <span className="text-xs" data-id="element-2568">
                      Analisis performa (in progress)
                    </span>
                  </div>
                </div>
                <div className="mt-3 flex justify-end" data-id="element-2569">
                  <button className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-2570">
                    Lihat Detail
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Notification Routes */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2571">
          <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2572">
            <h2 className="font-bold text-secondary" data-id="element-2573">Rute Notifikasi</h2>
          </div>
          <div className="p-4" data-id="element-2574">
            <div className="space-y-3" data-id="element-2575">
              <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2576">
                <h3 className="font-medium text-secondary text-sm mb-2" data-id="element-2577">
                  Kontrak & Lisensi
                </h3>
                <div className="space-y-2" data-id="element-2578">
                  <div className="flex items-center justify-between" data-id="element-2579">
                    <span className="text-xs" data-id="element-2580">In-app</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2581">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2582">
                    <span className="text-xs" data-id="element-2583">Email Dinas</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2584">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2585">
                    <span className="text-xs" data-id="element-2586">WhatsApp Gateway</span>
                    <span className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded-full" data-id="element-2587">
                      Nonaktif
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2588">
                <h3 className="font-medium text-secondary text-sm mb-2" data-id="element-2589">
                  Infrastruktur & Server
                </h3>
                <div className="space-y-2" data-id="element-2590">
                  <div className="flex items-center justify-between" data-id="element-2591">
                    <span className="text-xs" data-id="element-2592">In-app</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2593">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2594">
                    <span className="text-xs" data-id="element-2595">Email Dinas</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2596">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2597">
                    <span className="text-xs" data-id="element-2598">WhatsApp Gateway</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2599">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2600">
                    <span className="text-xs" data-id="element-2601">Telegram Gateway</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2602">
                      Aktif
                    </span>
                  </div>
                </div>
              </div>
              <div className="border border-gray-200 p-3 rounded-lg" data-id="element-2603">
                <h3 className="font-medium text-secondary text-sm mb-2" data-id="element-2604">
                  Keamanan
                </h3>
                <div className="space-y-2" data-id="element-2605">
                  <div className="flex items-center justify-between" data-id="element-2606">
                    <span className="text-xs" data-id="element-2607">In-app</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2608">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2609">
                    <span className="text-xs" data-id="element-2610">Email Dinas</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2611">
                      Aktif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-2612">
                    <span className="text-xs" data-id="element-2613">SMS</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-2614">
                      Aktif
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4" data-id="element-2615">
              <button className="w-full bg-secondary text-white py-2 rounded-md hover:bg-opacity-90" data-id="element-2616">
                Konfigurasi Rute
              </button>
            </div>
          </div>
        </div>
        {/* Notification Statistics */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2617">
          <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2618">
            <h2 className="font-bold text-secondary" data-id="element-2619">Statistik Notifikasi</h2>
          </div>
          <div className="p-4" data-id="element-2620">
            <div className="space-y-4" data-id="element-2621">
              {/* Notifications by priority */}
              <div data-id="element-2622">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2623">
                  Berdasarkan Prioritas (7 hari terakhir)
                </h3>
                <div className="space-y-2" data-id="element-2624">
                  <div data-id="element-2625">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2626">
                      <span data-id="element-2627">Kritis</span>
                      <span data-id="element-2628">8</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2629">
                      <div className="bg-accent-red h-2 rounded-full" style={{
                      width: '32%'
                    }} data-id="element-2630"></div>
                    </div>
                  </div>
                  <div data-id="element-2631">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2632">
                      <span data-id="element-2633">Warning</span>
                      <span data-id="element-2634">12</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2635">
                      <div className="bg-yellow-500 h-2 rounded-full" style={{
                      width: '48%'
                    }} data-id="element-2636"></div>
                    </div>
                  </div>
                  <div data-id="element-2637">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2638">
                      <span data-id="element-2639">Info</span>
                      <span data-id="element-2640">15</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2641">
                      <div className="bg-accent-info h-2 rounded-full" style={{
                      width: '60%'
                    }} data-id="element-2642"></div>
                    </div>
                  </div>
                  <div data-id="element-2643">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2644">
                      <span data-id="element-2645">Sukses</span>
                      <span data-id="element-2646">5</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2647">
                      <div className="bg-green-500 h-2 rounded-full" style={{
                      width: '20%'
                    }} data-id="element-2648"></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Notifications by category */}
              <div data-id="element-2649">
                <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2650">
                  Berdasarkan Kategori (7 hari terakhir)
                </h3>
                <div className="space-y-2" data-id="element-2651">
                  <div data-id="element-2652">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2653">
                      <span data-id="element-2654">Infrastruktur</span>
                      <span data-id="element-2655">14</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2656">
                      <div className="bg-secondary h-2 rounded-full" style={{
                      width: '56%'
                    }} data-id="element-2657"></div>
                    </div>
                  </div>
                  <div data-id="element-2658">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2659">
                      <span data-id="element-2660">Keamanan</span>
                      <span data-id="element-2661">7</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2662">
                      <div className="bg-secondary h-2 rounded-full" style={{
                      width: '28%'
                    }} data-id="element-2663"></div>
                    </div>
                  </div>
                  <div data-id="element-2664">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2665">
                      <span data-id="element-2666">Pemeliharaan</span>
                      <span data-id="element-2667">10</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2668">
                      <div className="bg-secondary h-2 rounded-full" style={{
                      width: '40%'
                    }} data-id="element-2669"></div>
                    </div>
                  </div>
                  <div data-id="element-2670">
                    <div className="flex justify-between text-xs mb-1" data-id="element-2671">
                      <span data-id="element-2672">Kontrak</span>
                      <span data-id="element-2673">5</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2674">
                      <div className="bg-secondary h-2 rounded-full" style={{
                      width: '20%'
                    }} data-id="element-2675"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notification Settings Modal */}
      {showSettings && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-2676">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl" data-id="element-2677">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-2678">
              <h2 className="text-xl font-bold text-secondary" data-id="element-2679">
                Pengaturan Notifikasi
              </h2>
              <button onClick={toggleSettings} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-2680">
                <XIcon size={20} className="text-gray-500" data-id="element-2681" />
              </button>
            </div>
            <div className="p-6 max-h-[80vh] overflow-y-auto" data-id="element-2682">
              <div className="space-y-6" data-id="element-2683">
                {/* Email Notifications */}
                <div data-id="element-2684">
                  <h3 className="text-lg font-medium text-secondary mb-3" data-id="element-2685">
                    Email Notifications
                  </h3>
                  <div className="space-y-3" data-id="element-2686">
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2687">
                      <div data-id="element-2688">
                        <p className="font-medium text-secondary" data-id="element-2689">
                          Notifikasi Kritis
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2690">
                          Kirim email untuk semua notifikasi prioritas kritis
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2691">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2692" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2693"></div>
                      </label>
                    </div>
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2694">
                      <div data-id="element-2695">
                        <p className="font-medium text-secondary" data-id="element-2696">
                          Notifikasi Warning
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2697">
                          Kirim email untuk notifikasi prioritas warning
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2698">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2699" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2700"></div>
                      </label>
                    </div>
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2701">
                      <div data-id="element-2702">
                        <p className="font-medium text-secondary" data-id="element-2703">
                          Notifikasi Info
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2704">
                          Kirim email untuk notifikasi prioritas info
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2705">
                        <input type="checkbox" className="sr-only peer" data-id="element-2706" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2707"></div>
                      </label>
                    </div>
                  </div>
                </div>
                {/* SMS Notifications */}
                <div data-id="element-2708">
                  <h3 className="text-lg font-medium text-secondary mb-3" data-id="element-2709">
                    SMS Notifications
                  </h3>
                  <div className="space-y-3" data-id="element-2710">
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2711">
                      <div data-id="element-2712">
                        <p className="font-medium text-secondary" data-id="element-2713">
                          Notifikasi Kritis
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2714">
                          Kirim SMS untuk notifikasi prioritas kritis
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2715">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2716" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2717"></div>
                      </label>
                    </div>
                  </div>
                </div>
                {/* WhatsApp Notifications */}
                <div data-id="element-2718">
                  <h3 className="text-lg font-medium text-secondary mb-3" data-id="element-2719">
                    WhatsApp Notifications
                  </h3>
                  <div className="space-y-3" data-id="element-2720">
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2721">
                      <div data-id="element-2722">
                        <p className="font-medium text-secondary" data-id="element-2723">
                          Notifikasi Kritis
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2724">
                          Kirim WhatsApp untuk notifikasi prioritas kritis
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2725">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2726" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2727"></div>
                      </label>
                    </div>
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2728">
                      <div data-id="element-2729">
                        <p className="font-medium text-secondary" data-id="element-2730">
                          Notifikasi Warning
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2731">
                          Kirim WhatsApp untuk notifikasi prioritas warning
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2732">
                        <input type="checkbox" className="sr-only peer" data-id="element-2733" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2734"></div>
                      </label>
                    </div>
                  </div>
                </div>
                {/* Notification Preferences */}
                <div data-id="element-2735">
                  <h3 className="text-lg font-medium text-secondary mb-3" data-id="element-2736">
                    Preferensi Notifikasi
                  </h3>
                  <div className="space-y-3" data-id="element-2737">
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2738">
                      <div data-id="element-2739">
                        <p className="font-medium text-secondary" data-id="element-2740">
                          Digest Harian
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2741">
                          Kirim ringkasan notifikasi harian
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2742">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2743" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2744"></div>
                      </label>
                    </div>
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2745">
                      <div data-id="element-2746">
                        <p className="font-medium text-secondary" data-id="element-2747">
                          Batasi Notifikasi
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2748">
                          Batasi jumlah notifikasi per jam
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2749">
                        <input type="checkbox" className="sr-only peer" data-id="element-2750" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2751"></div>
                      </label>
                    </div>
                    <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2752">
                      <div data-id="element-2753">
                        <p className="font-medium text-secondary" data-id="element-2754">
                          Notifikasi Desktop
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-2755">
                          Tampilkan notifikasi desktop saat aplikasi berjalan
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2756">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2757" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-2758"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-2759">
              <button onClick={toggleSettings} className="px-4 py-2 border border-gray-300 rounded-md text-sm mr-2 hover:bg-gray-100" data-id="element-2760">
                Batal
              </button>
              <button className="px-4 py-2 bg-primary text-secondary rounded-md hover:bg-opacity-90 text-sm font-medium" onClick={toggleSettings} data-id="element-2761">
                Simpan Pengaturan
              </button>
            </div>
          </div>
        </div>}
    </div>;
};